<template>
  <card class="card" :title="title" style="color:blue;font-size: 30px;">
    <div>
      <ul class="list-unstyled team-members" >
        <li>
          <div class="row mt-1" v-for="member in personasrep" :key="member.name" style="border-bottom: 3px solid rgba(128, 128, 128, 0.3);; margin-left: 10px; margin-right: 10px; ">
            <div class="col-2 justify-content-center d-flex" >
              <div class="avatar">
                <img
                  :src="rutaApp +'storage/documents/' + member.Foto"
                  alt="N"
                  class="rounded img-fluid"
                />
              </div>
            </div>
            <div class="col-10 justify-content-center aling-items-center ">
              <p style="margin: 0px;" class="text-primary"> {{ member.Persona }} </p>
              <p  class="text-secondary"> {{ member.email }} - {{ member.Celular }} </p>
              <hr>


              <!-- <span :class="getStatusClass(member.status)">
                <small>{{ member.status }}</small>
              </span> -->
            </div>



            <!-- <div class="col-3 justify-content-center d-flex">
              <p-button type="success" outline icon>
                <i class="fa fa-envelope"></i>
              </p-button>
            </div> -->

            
          </div>

        </li>
      </ul>
    </div>

    
    <!-- <div>
      <vue-advanced-chat
        height="calc(100vh - 20px)"
        :current-user-id="currentUserId"
        :rooms="JSON.stringify(rooms)"
        :rooms-loaded="true"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messagesLoaded"
        @send-message="sendMessage($event.detail[0])"
        @fetch-messages="fetchMessages($event.detail[0])"
      />
    </div> -->

  </card>


  
</template>
<script>

import { register } from 'vue-advanced-chat'
register()

import MainService from "@/services/MainService.js";

export default {
  metaInfo: {
    // Configura los encabezados de respuesta para evitar la caché
    httpEquiv: {
      'Cache-Control': 'no-store',
      Expires: 'Thu, 01 Jan 1970 00:00:00 GMT',
      Pragma: 'no-cache'
    }
  },
  
  data() {
    return {
      ss: new MainService(),
      title: "Miembros del equipo",
      members: [
        {
          image: require("@/assets/img/faces/face-0.jpg"),
          name: "Dj Khaled",
          status: "Offline",
        },
        {
          image: require("@/assets/img/faces/face-1.jpg"),
          name: "Henry ",
          status: "Available",
        },
        {
          image: require("@/assets/img/faces/face-1.jpg"),
          name: "Flume",
          status: "Busy",
        },
      ],

      // chat
      currentUserId: '1234',
			rooms: [
				{
					roomId: '1',
					roomName: 'Escuela',
					avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj',
					users: [
						{ _id: '1234', username: 'John Doe' },
						{ _id: '4321', username: 'John Snow' }
					]
				},
				{
					roomId: '1',
					roomName: 'Cariñosas',
					avatar: 'https://66.media.tumblr.com/avatar_c6a8eae4303e_512.pnj',
					users: [
						{ _id: '1234', username: 'John Doe' },
						{ _id: '4321', username: 'John Snow' }
					]
				}
			],
			messages: [],
			messagesLoaded: false,
      auth:{},
      personasrep:[],
      rutaApp:process.env.VUE_APP_RRHH_SERVICE,
      // fin chat
    };
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case "Offline":
          return "text-muted";
        case "Available":
          return "text-success";
        case "Busy":
          return "text-danger";
        default:
          return "text-success";
      }
    },

    // chat

    fetchMessages({ options = {} }) {
    setTimeout(() => {
      if (options.reset) {
        this.messages = this.addMessages(true)
      } else {
        this.messages = [...this.addMessages(), ...this.messages]
        this.messagesLoaded = true
      }
      // this.addNewMessage()
    })
		},

    addMessages(reset) {
			const messages = []

			for (let i = 0; i < 30; i++) {
				messages.push({
					_id: reset ? i : this.messages.length + i,
					content: `${reset ? '' : 'paginated'} message ${i + 1}`,
					senderId: '4321',
					username: 'John Doe',
					date: '13 November',
					timestamp: '10:20'
				})
			}

			return messages
		},

    sendMessage(message) {
			this.messages = [
				...this.messages,
				{
					_id: this.messages.length,
					content: message.content,
					senderId: this.currentUserId,
					timestamp: new Date().toString().substring(16, 21),
					date: new Date().toDateString()
				}
			]
		},

    addNewMessage() {
			setTimeout(() => {
				this.messages = [
					...this.messages,
					{
						_id: this.messages.length,
						content: 'NEW MESSAGE',
						senderId: '1234',
						timestamp: new Date().toString().substring(16, 21),
						date: new Date().toDateString()
					}
				]
			}, 2000)
		},



    getPersonasReparticion() {
      
        console.log("repsasas"); 
        this.ss.listPersonasReparticion(this.auth.id).then(
            (result) => {
                let response = result.data;
                this.personasrep = response.personas;
      
            }
        ).catch(error => {
            console.log(error);
            this.isLoading=false;
        });
    },
	},
   mounted() {
        this.auth = JSON.parse(localStorage.getItem('usuario'));
        // console.log(this.auth);
        if (!this.auth) {
            // this.$router.push('/Login');
        } else {
            
            this.getPersonasReparticion();
            // this.print();
            
        }
    }
  
};
</script>


<style lang="scss">
body {
	font-family: 'Quicksand', sans-serif;
}
</style>
